import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/article.ts

var article_exports = {};

__export(article_exports, {
  getArticle: function getArticle() {
    return _getArticle;
  },
  getArticleList: function getArticleList() {
    return _getArticleList;
  },
  getSixGroupDetail: function getSixGroupDetail() {
    return _getSixGroupDetail;
  },
  setArticleQuestionComplete: function setArticleQuestionComplete() {
    return _setArticleQuestionComplete;
  }
});

var _getArticle = function _getArticle(_ref) {
  var id = _ref.id,
      type = _ref.type,
      uid = _ref.uid;

  if (type == "article") {
    return fetcher_default.get("/v4/public/articles/".concat(id));
  } else {
    if (uid) {
      return fetcher_default.get("/v4.1/courses/".concat(uid));
    } else if (id) {
      return fetcher_default.get("/v4/courses/".concat(id));
    }
  }
};

var _getArticleList = function _getArticleList(_ref2) {
  var id = _ref2.id;
  return fetcher_default.get("/v4/group_class_activities/courses", {
    client_id: id
  });
};

var _getSixGroupDetail = function _getSixGroupDetail(param) {
  return fetcher_default.get("/v4/public/six_group_courses", param);
};

var _setArticleQuestionComplete = function _setArticleQuestionComplete(_ref3) {
  var courseId = _ref3.courseId;
  return fetcher_default.post("/v4/courses/".concat(courseId, "/complete"));
};

export { _getArticle as getArticle, _getArticleList as getArticleList, _getSixGroupDetail as getSixGroupDetail, _setArticleQuestionComplete as setArticleQuestionComplete, article_exports };